var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircleRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4002 21.5999C17.7021 21.5999 22.0002 17.3018 22.0002 11.9999C22.0002 6.69797 17.7021 2.3999 12.4002 2.3999C7.09824 2.3999 2.80017 6.69797 2.80017 11.9999C2.80017 17.3018 7.09824 21.5999 12.4002 21.5999ZM16.8487 11.0484C17.3173 10.5798 17.3173 9.82 16.8487 9.35137C16.3801 8.88275 15.6203 8.88275 15.1516 9.35137L11.2002 13.3028L9.6487 11.7514C9.18007 11.2827 8.42027 11.2827 7.95164 11.7514C7.48301 12.22 7.48301 12.9798 7.95164 13.4484L10.3516 15.8484C10.8203 16.3171 11.5801 16.3171 12.0487 15.8484L16.8487 11.0484Z",
    fill: "#FF5865"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleRed);
export default __webpack_public_path__ + "static/media/check-circle-red.189b9ad264904bdf85a6f90ac323d91d.svg";
export { ForwardRef as ReactComponent };